module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('datepicker', {
    attrs: {
      "readonly": true,
      "format": "MMM/D/YYYY",
      "id": "dateInput",
      "width": "100%"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("With icons")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("With border indicator")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', [_vm._v("Select Options")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(9)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Inputs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-at",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Username",
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-envelope"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "placeholder": "Email",
      "type": "email"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-success"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputSuccess"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  }), _vm._v(" Input with success")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputSuccess",
      "placeholder": "Enter ...",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Help block with success")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group has-error"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "inputError"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times-circle-o"
  }), _vm._v(" Input with error")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "inputError",
      "placeholder": "Enter ...",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Help block with error")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select")]), _vm._v(" "), _c('select', {
    staticClass: "form-control"
  }, [_c('option', [_vm._v("option 1")]), _vm._v(" "), _c('option', [_vm._v("option 2")]), _vm._v(" "), _c('option', [_vm._v("option 3")]), _vm._v(" "), _c('option', [_vm._v("option 4")]), _vm._v(" "), _c('option', [_vm._v("option 5")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Multiple")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "multiple": ""
    }
  }, [_c('option', [_vm._v("option 1")]), _vm._v(" "), _c('option', [_vm._v("option 2")]), _vm._v(" "), _c('option', [_vm._v("option 3")]), _vm._v(" "), _c('option', [_vm._v("option 4")]), _vm._v(" "), _c('option', [_vm._v("option 5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24603d00"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Setting.vue
// module id = 1860
// module chunks = 1